import { createContext, useState } from "react";

export const TextingComponentContext = createContext();

const TextingComponentProvider = ({ children }) => {

    const [isTextFormDirty, setIsTextFormDirty] = useState(false);


    return (
        <TextingComponentContext.Provider value={{ isTextFormDirty, setIsTextFormDirty }}>
            {children}
        </TextingComponentContext.Provider>
    );
};

export default TextingComponentProvider;
